import { z } from 'zod';
import { AiFeature, AiModelTier } from './ai.js';
import { ManualAlternative } from './ai-capability.js';
import { AiRunLimitKey, AiRunLimits, ConstraintSource } from './ai-policy.js';
/**
 * Registry và chạy tool lẻ cho trang Harness — APM-H-e.
 *
 * Khác `AiCapabilities` (cho người dùng: skill nào bấm được) — đây là góc nhìn
 * người vận hành: mọi skill và tool đang đăng ký, kể cả thứ người xem không có
 * quyền dùng, kèm luật hiệu lực và schema đầu vào của tool.
 */
export const AiHarnessSkillEntry = z.object({
    name: z.string(),
    feature: AiFeature,
    title: z.string(),
    description: z.string(),
    tier: AiModelTier,
    requiredPermission: z.string(),
    tools: z.array(z.string()),
    manual: ManualAlternative,
    /** Trần hiệu lực (mặc định ← tổ chức ← skill) và nguồn từng số. */
    constraints: z.object({
        limits: AiRunLimits,
        sources: z.record(AiRunLimitKey, ConstraintSource),
    }),
    /** Phiên bản prompt đang hoạt động — `null` cho tới APM-H-f. */
    promptVersion: z.string().nullable(),
    /** JSON Schema của `params` skill nhận — form "chạy thử" dựng từ đây (APM-H-h). `null` = skill không khai, nhập JSON tay. */
    paramsSchema: z.record(z.string(), z.unknown()).nullable(),
    /** Tag kiến thức (APM-H-i) và mức suy nghĩ skill khai (APM-H-l) — để đọc registry là biết skill đọc gì, nghĩ bao sâu. */
    knowledgeTags: z.array(z.string()),
    reasoning: z.string().nullable(),
});
export const AiHarnessToolEntry = z.object({
    name: z.string(),
    description: z.string(),
    /** JSON Schema sinh từ Zod `input` — form "chạy tool lẻ" dựng từ đây. */
    inputSchema: z.record(z.string(), z.unknown()),
    requiredPermission: z.string(),
    readOnly: z.boolean(),
    crossProject: z.boolean(),
    /** Skill nào khai tool này. */
    usedBy: z.array(z.string()),
});
export const AiHarnessRegistry = z.object({
    skills: z.array(AiHarnessSkillEntry),
    tools: z.array(AiHarnessToolEntry),
});
export const ExecuteToolInput = z.object({
    projectId: z.uuid(),
    input: z.record(z.string(), z.unknown()),
});
export const ExecuteToolResult = z.object({
    tool: z.string(),
    ms: z.number().int().nonnegative(),
    /** Ước lượng token của `output` khi JSON hoá — cùng công thức `ContextBudget`. */
    estimatedTokens: z.number().int().nonnegative(),
    output: z.unknown(),
});
//# sourceMappingURL=ai-harness.js.map